import { Injectable } from '@angular/core';
import { ApiService } from 'app/services/api.service';
import { PsalterSearchModel } from '../components/psalter-search/psalter-search.component';
import { LectionarySource } from './lectionary-source.service';
import { Localized } from 'app/objects';

@Injectable({
  providedIn: 'root'
})
export class PsalterService {

constructor(private apiSvc: ApiService) { }

  public loadEntities(model: PsalterSearchModel): Promise<PsalterSummary[]> {

    const p = new Promise<PsalterSummary[]>((resolve, reject) => {

      this.apiSvc.post("api/psalter/GetSummaryList", model).subscribe(
        (data: PsalterSummary[]) => {
          console.log("loadEntities", data);
          resolve(data);
        },
        (err) => {
          console.log("error", err);
        }
      );

    });

    return p;
  }

  public getItem(itemId: number): Promise<Psalter> {

    const p = new Promise<Psalter>((resolve, reject) => {

      this.apiSvc.get("api/psalter/GetItem/" + itemId, null).subscribe(
        (data: Psalter) => {
          console.log("psalter/GetItem", data);
          resolve(data);
        },
        (err) => {
          console.log("error", err);
        }
      );

    });

    return p;
  }

  public save(psalter: Psalter, isProofed: boolean): Promise<PsalterSummary> {
  
    const p = new Promise<PsalterSummary>((resolve, reject) => {
 
      var payload = {
        Psalter: psalter,
        IsProofed: isProofed
      };
  
      console.log("Saving Psalter", payload);

      this.apiSvc.post("api/psalter/save", payload).subscribe(
        (data: PsalterSummary) => { 
          console.log(data);  
          resolve(data);
        },
        (err) => {
          console.log("error", err);
          reject(err);
        //  this.isLoading = false;
        }
      );

    });

    return p;  
  }

  public delete(psalterId: number): Promise<void> {
  
    const p = new Promise<void>((resolve, reject) => {
 
      var payload = {
        Id: psalterId, 
      };
  
      console.log("Deleting Psalter", payload);

      this.apiSvc.post("api/psalter/delete", payload).subscribe(
        (data: PsalterSummary) => { 
          console.log(data);  
          resolve();
        },
        (err) => {
          console.log("error", err);
          reject(err);
        //  this.isLoading = false;
        }
      );

    });

    return p;  
  }

  public getPsalterHtml(passage: string, lectionarySourceId: number): Promise<string>  {

    const p = new Promise<string>((resolve, reject) => {
 
      var payload = {
        Passage: passage,
        LectionarySourceId: lectionarySourceId
      };
  
      console.log("Saving Psalter", payload);

      this.apiSvc.post("api/psalter/getHtml", payload).subscribe(
        (data: string) => { 
          console.log(data);  
          resolve(data);
        },
        (err) => {
          console.log("error", err);
          reject(err); 
        }
      );

    });

    return p;  

  }  

}
 

export class Psalter {
  Id: number; 
  LectionarySource: LectionarySource; 
  Page: any;
  Chapter: any; 
  Verse: string;
  Part: number;
  Book: number;
  Day: number;
  ProofedByName: string;
  Localized: Localized[];
} 

export class PsalterSummary {
  Id: number; 
  LectionarySourceName: string;
  Chapter: any; 
  Verse: string;
  Part: number;
  Line: number;
  Book: number;
  Day: number;
  Letter: string;
  Html: string;
  IsProofed: boolean;
  IsSpaceAfter: boolean;
  AvailableSearchTerms: string[];
}